<template>
	<div>
        <h4>
            <span :class="'badge badge-'+(count && cell.min_highlight_count && cell.label_color && count >= cell.min_highlight_count ? cell.label_color : 'default')">{{ count }}</span> {{ cell.filter_name }}<br/>
            <span class="text-muted small">{{ label }}<span v-show="count > 1 && pluralize">s</span></span>
        </h4>

        <a :href="`${url}`" target="_blank" v-if="url">View Results</a>
        <a href="javascript:void(0)" v-on:click="$emit('toggleDashResults', cell.id)" v-if="false">{{ cell.show_list ? 'Hide' : 'View' }} Results</a>
    </div>
</template>

<script>
    export default {
        props: {
            count: {
                type: Number,
                required: true,
            },

            cell: {
                type: Object,
                required: true,
            },

            url: {
                type: String,
                default: null,
            },

            pluralize: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {
            label(){
                //Send it
                return this.$root.getPrettyAssetName(this.cell.asset_type);
            },
        },

        methods: {

        },

        mounted() {

        }
    }
</script>